import { glossary } from '../../../localization/global';
import { LangSupplierQuoteItemContentType } from '../../../localization/scripts/quotes/supplier-quote-item-content-type-lang';

/// <summary>
/// examples
///   QuoteItemType.Provider (reserved 1000+)
///     1000 = frame
///     1001 = component DataProvider.Data = " { objectreference: "bla", libid, id, classid }
///     1002 = extn
///   QuoteItemType.Basic (reserved 1)
///     1 = Shipping
///     2 = Freehand
/// </summary>

//properties for QuoteItemType on the quote item, when the provider is v6,
//but we will expect other providers to map and use the same values for consistency

export const supplierQuoteItemContentType = {
  CID_FRAM: 7,
  CID_COMP: 2,
  CID_EXTN: 3,
  CID_FILL: 4,
  CID_IGU: 90, //QTE_IGU = 52, but we don't need
  CID_LOUVRE: 100, //TODO - put real value,
  CID_FREEHAND: 10
};

const UNIT_TYPE_INDIVIDUAL = 'individual';
const UNIT_TYPE_A2 = 'a2';
const UNIT_TYPE_LENGTH = 'length';
const UNIT_TYPE_NONE = 'none';

export function supplierItemContentTypeDisplay(contentType: number, plural?: boolean, includeUnit?: boolean) {
  let tagValue: string;
  let unitType: string;

  switch (contentType) {
    case supplierQuoteItemContentType.CID_FRAM:
      tagValue = 'frame';
      unitType = UNIT_TYPE_INDIVIDUAL;
      break;
    case supplierQuoteItemContentType.CID_COMP:
      tagValue = 'component';
      unitType = UNIT_TYPE_INDIVIDUAL;
      break;
    case supplierQuoteItemContentType.CID_EXTN:
      tagValue = 'extrusion';
      unitType = UNIT_TYPE_LENGTH;
      break;
    case supplierQuoteItemContentType.CID_FILL:
      tagValue = 'fill';
      unitType = UNIT_TYPE_A2;
      break;
    case supplierQuoteItemContentType.CID_IGU:
      tagValue = 'igu';
      unitType = UNIT_TYPE_A2;
      break;
    case supplierQuoteItemContentType.CID_FREEHAND:
      tagValue = 'freehand';
      unitType = UNIT_TYPE_INDIVIDUAL;
      break;
    case supplierQuoteItemContentType.CID_LOUVRE:
      tagValue = 'louvre';
      unitType = UNIT_TYPE_A2;
      break;
    default:
      tagValue = 'Unknown Type';
      unitType = UNIT_TYPE_NONE;
      break;
  }

  if (!includeUnit) {
    unitType = UNIT_TYPE_NONE;
  }

  return LangSupplierQuoteItemContentType.toDisplay(glossary(`${tagValue}${plural ? ':plural' : ''}`), unitType);
}
